import { push } from 'connected-react-router'
import * as type from './type'
import * as selector from './selector'

export const changeBarCode = (name, value) => ({
    type: type.CHANGE_BAR_CODE,
    payload: {
        name,
        value,
    },
})

export const onBarCodeEnter = () => (dispatch, getState) => {
    const state = getState()
    const barcode = selector.selectBarCode(state)
    if (!barcode || !barcode.value) {
        return
    }
    const partList = barcode.value.split('.')

    if (partList.length !== 2) {
        return
    }
    let instanceId = partList[1]
    instanceId = instanceId.replace(/ß/g, '-')
    dispatch(push('/task/detail-by-process-instance-id/' + instanceId))
    dispatch(changeBarCode('value', ''))
}



// WEBPACK FOOTER //
// ./src/modules/process/state/barcode/action.js